<template>
  <div class="w-full min-w-0 pt-2 flex flex-col gap-4 h-full">
    <div class="flex items-center cursor-pointer" @click="emit('back')">
      <ArrowLeft class="h-5 w-5 shrink-0" />
      <span class="flex-grow text-xl font-semibold text-center">Checkout</span>
    </div>

    <div v-if="isLoading" class="flex flex-col items-center justify-center py-8 gap-2">
      <LayupSpinner />
      <p class="text-sm text-grey-light-600">Loading payment form...</p>
    </div>

    <div v-if="errorResponse.message || errorResponse.title" class="flex flex-col flex-auto text-center">
      <p class="text-black text-lg font-bold">{{ errorResponse.title }}</p>
      <ErrorDisplay :errorMessage="errorResponse.message" showBackButton />
    </div>

    <div v-show="!isLoading && !errorResponse.message" class="grow min-w-0 overflow-y-auto">
      <div
        id="contribute-payment-form"
        class="origin-top-left w-full"
        :class="{ 'h-[550px]': checkoutFormLoaded }"
      ></div>
    </div>

    <div class="flex justify-between items-center py-2 border-t mt-auto">
      <p class="text-sm font-bold">Amount Due</p>
      <p class="text-sm font-bold">{{ displayCurrency(props.amountCents) }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import ErrorDisplay from '@/components/common/ErrorDisplay.vue';
import LayupSpinner from '@/components/common/LayupSpinner.vue';
import { usePeachCheckout } from '@/composables/usePeachCheckout';
import { displayCurrency } from '@/utils/format.utils';
import { hideFreshchatWhileOpen } from '@/utils/freshchat.utils';
import { ArrowLeft } from 'lucide-vue-next';
import { onMounted } from 'vue';

const props = defineProps<{
  paymentPlanId: string;
  amountCents: number;
  paymentMethod: 'CARD' | 'EFT';
}>();

const emit = defineEmits<{
  completed: [paymentId: string];
  cancelled: [];
  back: [];
}>();

hideFreshchatWhileOpen();

const { isLoading, errorResponse, checkoutFormLoaded, initiate } = usePeachCheckout({
  formElementId: 'contribute-payment-form',
  channel: 'shopper_contribute',
  themeColor: '#0f7d88',
  onCompleted: (paymentId) => emit('completed', paymentId),
  onCancelled: () => emit('cancelled'),
});

onMounted(() => initiate(props.paymentPlanId, props.amountCents, props.paymentMethod));
</script>
